export default {
  //--------------------------------------------------------------------//
  BFS: {
    emailid: 'Email Address',
    emailid_worder: 'Email Address',
    email: 'Email Address',
    oth_email: 'Email Address for this booking',
    email_confirm: 'Confirm Email Address',
    companyname: 'Company Name',
    title: 'Title',
    firstname: 'Forename',
    surname: 'Surname',
    mobilenumber: 'Mobile Number',
    state: 'Address',
    country: 'Country',
    address: 'Address Line 1',
    address_line_2: 'Address Line 2',
    town: 'Town',
    state_province: 'State/Province',
    postcode: 'Postcode',
    vehicle_vrn: 'Vehicle Registration (no spaces please)',
    vrn_color: 'Primary Colour',
    vrn_make: 'Make',
    vrn_model: 'Model',
    reason: 'Purpose of Travel',
    remember_device: 'Remember this device for faster future logins',
  },
  ST1: {
    postcode: 'ZIP Code',
  },
}